import { useState } from "react";

const useDocumentUploader = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [uploadedDocumnetUrl, setUploadedDocumnetUrl] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false); // Custom loading state

  const uploadDocumnetImage = async (image) => {
    if (!image) {
      setErrorMessage("No image provided for upload.");
      return;
    }

    setLoading(true); // Start loading
    setErrorMessage(null);

    try {
      const formData = new FormData();
      formData.append("image", image);

      const token = localStorage.getItem("token"); // Retrieve token from localStorage

      const response = await fetch(`${baseURL}/profile/upload`, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
          ...(token && { Authorization: `Bearer ${token}` }), // Add token to headers if it exists
        },
      });

      if (!response.ok) {
        throw new Error("Failed to upload image");
      }

      const data = await response.json();

      if (data?.statusCode === 200) {
        setUploadedDocumnetUrl(data?.data?.url); // Update URL on success
      } else {
        setErrorMessage("Image URL not returned in the response.");
      }
    } catch (error) {
      console.error("Error during image upload:", error);
      setErrorMessage(error.message || "Failed to upload image.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return { uploadDocumnetImage, uploadedDocumnetUrl, loading, errorMessage };
};

export default useDocumentUploader;

